module.exports = {
  SEO_REVIEWS_LIMIT: 30,
  SEO_REVIEWS_DEFAULT_SORT_OPTION: 'MOST_RELEVANT',
  VALID_SORT_OPTIONS: [
    'MOST_RELEVANT',
    'PHOTO_REVIEWS',
    'NEWEST',
    'OLDEST',
    'HIGHEST_RATING',
    'LOWEST_RATING',
  ],
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/server/utils/server-constants.js